var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 15.84c-4.97 0-9-3.868-9-8.64 0-.68.082-1.344.238-1.98C5.716 6.514 4 9.065 4 12c0 4.241 3.582 7.68 8 7.68 3.058 0 5.716-1.647 7.062-4.068A9.4 9.4 0 0 1 17 15.84m2.881-2.514A7.2 7.2 0 0 1 17 13.92c-3.866 0-7-3.009-7-6.72 0-.986.221-1.922.619-2.766A6.7 6.7 0 0 1 12.1 2.4H12c-.944 0-1.856.125-2.722.36C5.078 3.898 2 7.604 2 12c0 5.302 4.477 9.6 10 9.6 4.58 0 8.44-2.955 9.625-6.987.244-.83.375-1.707.375-2.613v-.097l-.101.097c-.583.548-1.265 1-2.018 1.326",
    clipRule: "evenodd"
  })));
};
export default SvgMoon;